export type V10AgencyExportCategory = "evidence" | "approval" | "delivery" | "operational";

export type V10AgencyExportSuiteEntry = {
  readonly id: string;
  readonly category: V10AgencyExportCategory;
  readonly label: string;
  readonly description: string;
  readonly actionLabel: string;
};

export const V10_AGENCY_EXPORT_SUITE: readonly V10AgencyExportSuiteEntry[] = [
  {
    id: "export-evidence",
    category: "evidence",
    label: "Evidence bundle",
    description: "Launch proof and search readiness reports for agency/client review.",
    actionLabel: "View evidence panels",
  },
  {
    id: "export-approval",
    category: "approval",
    label: "Approval record",
    description: "Client approval decision tied to the latest passing artifact set.",
    actionLabel: "Open approval section",
  },
  {
    id: "export-delivery",
    category: "delivery",
    label: "Departure Kit delivery",
    description: "Client-friendly handoff zip when issuance is READY.",
    actionLabel: "Download Departure Kit",
  },
  {
    id: "export-operational",
    category: "operational",
    label: "Operational run export",
    description: "Generation/export run package for internal ops and audit trails.",
    actionLabel: "Queue run export",
  },
] as const;

export function assertAgencyExportSuiteComplete(): boolean {
  const categories = new Set(V10_AGENCY_EXPORT_SUITE.map((e) => e.category));
  return (
    categories.has("evidence") &&
    categories.has("approval") &&
    categories.has("delivery") &&
    categories.has("operational") &&
    V10_AGENCY_EXPORT_SUITE.length === 4
  );
}
